module.exports = __webpack_public_path__ + "img/58.9e88a9f6.png";